export const ROUTE_GENERATE_DRAFT = '/draft/generate/:entity(book|order)/:id';

export const ROUTE_DRAFT = '/draft/:draftId';
export const ROUTE_DRAFT_VIEW = `${ROUTE_DRAFT}`;
